
const SplashScreen = ({ error }) => {
  const isMM6MM = process.env.REACT_APP_PROJECT_ID === "mm6mm";

  if (isMM6MM) {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: '#282c34', // Matches --body_background for dark theme
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            flexDirection: 'column'
        }}>
            {error ? (
                 <h1 style={{ color: 'white' }}>{error}</h1>
            ) : (
                <div className="spinner-border text-light" role="status" style={{ width: "3rem", height: "3rem" }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
            )}
        </div>
    );
  }

  return <>Loading</>;
};

export default SplashScreen;
